<template>
  <div
    :class="[
      $style.root,
      {
        [$style.disabled]: disabled,
        [$style.alert]: alert,
      },
    ]"
    @keydown="onRadioKeyDown"
  >
    <slot :checked="checked" />
  </div>
</template>

<script setup lang="ts">
import { onRadioKeyDown } from "./checkableKeyboard";

withDefaults(
  defineProps<{
    disabled?: boolean;
    checked?: boolean;
    alert?: boolean;
  }>(),
  {
    disabled: false,
    checked: false,
    alert: false,
  },
);
</script>

<style lang="scss" module>
@use "../styles/helpers/checkable.scss" as Checkable;

.root {
  @include Checkable.radio($disabled: ".disabled");

  &.alert {
    --sca-radio-border-color: var(--color-interaction-border-alert);
  }
}
</style>
